import React from 'react';
import type { PatientDetailsPatientProp } from './internal';
import { PatientDetailsSection } from './internal';
import { intl } from '../../lib';
import { Collapsible } from '../basic';
import { QRCode } from '../basic/QRCode';

/**
 * Props for a {@link PatientDetailsQRcode} component.
 */
export type PatientDetailsQRcodeProps = PatientDetailsPatientProp & {
  readonly openInitially?: boolean;
};

/**
 * Component for displaying a patient's QR code for mobile app.
 *
 * @param properties a {@link PatientDetailsPatientProp} object
 * @return the created {@link React.JSX.Element}.
 * @constructor
 */
export function PatientDetailsQRcode({
  patient,
  openInitially = false,
  ...props
}: Readonly<PatientDetailsQRcodeProps>): React.JSX.Element {
  if (!patient.qrcodeSVG) {
    return <></>;
  }

  return (
    <PatientDetailsSection {...props} className="ehs-patient-details-qr-code">
      <Collapsible
        triggerText={intl('patientsearchportlet.view.details.qrcode')}
        aria-label={intl('patientsearchportlet.view.details.qrcode')}
        openInitially={openInitially}
      >
        <QRCode
          className="qr-code-svg"
          qrcodeSVG={patient.qrcodeSVG}
          width={100}
          height={100}
        />
      </Collapsible>
    </PatientDetailsSection>
  );
}
